export default __webpack_public_path__ + "static/media/amaze-6.e1f256f4.jpg";